import { render, staticRenderFns } from "./harmfulFactors.vue?vue&type=template&id=69d03806"
import script from "./harmfulFactors.vue?vue&type=script&lang=js"
export * from "./harmfulFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d03806')) {
      api.createRecord('69d03806', component.options)
    } else {
      api.reload('69d03806', component.options)
    }
    module.hot.accept("./harmfulFactors.vue?vue&type=template&id=69d03806", function () {
      api.rerender('69d03806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/harmfulFactors.vue"
export default component.exports